// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useState } from 'react';
import { Card, TextField, Typography } from '@mui/material';
import { useLimits } from '../../contexts/LimitsContext';

const isValidLimit = (value: number) => Number.isFinite(value) && value > 0;

export const OperationLimits: React.FC = () => {
  const { mintLimit, burnLimit, setMintLimit, setBurnLimit } = useLimits();
  const [mintLimitInput, setMintLimitInput] = useState(mintLimit.toString());
  const [burnLimitInput, setBurnLimitInput] = useState(burnLimit.toString());

  return (
    <Card sx={{ mb: 1, width: '50%', p: 1 }} variant="outlined">
      <Typography fontWeight="bold" sx={{ mb: 1 }}>
        Operation Limits
      </Typography>
      <Typography variant="body2" sx={{ mb: 1 }}>
        Set the maximum allowed amount for mint and burn operations.
      </Typography>
      <TextField
        label="Mint Upper Limit"
        type="number"
        size="small"
        value={mintLimitInput}
        onChange={(e) => {
          const nextValue = e.target.value;
          setMintLimitInput(nextValue);

          const parsed = Number(nextValue);

          if (isValidLimit(parsed)) {
            setMintLimit(parsed);
          }
        }}
        onBlur={() => setMintLimitInput(mintLimit.toString())}
        inputProps={{ step: 'any' }}
        sx={{ mr: 2 }}
      />
      <TextField
        label="Burn Upper Limit"
        type="number"
        size="small"
        value={burnLimitInput}
        onChange={(e) => {
          const nextValue = e.target.value;
          setBurnLimitInput(nextValue);

          const parsed = Number(nextValue);
          if (isValidLimit(parsed)) {
            setBurnLimit(parsed);
          }
        }}
        onBlur={() => setBurnLimitInput(burnLimit.toString())}
        inputProps={{ step: 'any' }}
      />
    </Card>
  );
};
